export default {
  methods: {
    currency: function (value) {
      return value / 100
    },

    isAndroid: function (platform) {
      return platform === 'Android'
    },

    isEmptyObject: function (obj) {
      return Object.keys(obj).length === 0
    },

    isFireTV: function (platform) {
      return platform === 'amazon-fireos'
    }
  }
}
